var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMaurice = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 560,
    viewBox: "0 0 432 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 432,
    height: 560,
    fill: "#F4EFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.667 380.103L343.331 380.002C339.352 371.479 333.381 344.635 327.119 313.324C320.856 282.013 307.112 256.655 299.743 248.863C292.375 241.07 275.401 231.536 262.664 231.842C249.928 232.148 231.726 261.578 231.726 261.578C231.726 261.578 220.425 285.097 217.671 290.747C214.916 296.397 201.074 330.156 197.966 338.114C194.882 346.071 197.401 351.98 201.215 353.463C205.029 354.946 209.938 358.44 215.282 357.169C220.626 355.897 224.162 337.435 224.162 337.435L228.006 339.526C228.477 365.046 227.445 365.836 224.667 380.103Z",
    fill: "#040222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.006 339.526C228.477 365.046 227.445 365.836 224.667 380.103L343.331 380.002C339.352 371.479 333.381 344.635 327.119 313.324C320.856 282.013 307.112 256.655 299.743 248.863C292.375 241.07 275.401 231.536 262.665 231.842C249.928 232.148 231.726 261.578 231.726 261.578C231.726 261.578 220.425 285.097 217.671 290.747C214.916 296.397 201.074 330.156 197.966 338.114C194.882 346.071 197.401 351.98 201.215 353.463C205.029 354.946 209.938 358.44 215.282 357.169C220.626 355.897 224.162 337.435 224.162 337.435L228.006 339.526ZM228.006 339.526C227.535 314.006 232.173 278.505 232.173 278.505C232.173 278.505 227.182 316.996 228.006 339.526Z",
    stroke: "#040222",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M271.587 343.045L274.492 235.665L248.566 241.469L236.956 343.045H271.587Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.62158,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.589 268.538C255.589 268.538 251.068 269.869 248.962 272.949C248.846 264.273 250.379 262.663 250.413 246.18",
    stroke: "#040222",
    strokeWidth: 0.810791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M260.276 268.539C262.864 270.261 264.406 269.792 266.903 272.95C266.903 272.95 266.783 268.642 268.162 266.266C269.542 263.89 272.178 253.48 272.178 253.48",
    stroke: "#040222",
    strokeWidth: 0.810791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M257.553 276.531C257.023 276.893 256.281 277.785 257.553 278.454C259.142 279.291 259.561 277.451 258.474 276.531M256.634 297.275C256.55 296.885 256.65 296.087 257.721 296.02C259.059 295.937 258.889 297.944 258.137 298.111C257.384 298.279 256.493 298.072 256.634 297.275ZM256.437 318.331C256.158 317.578 256.002 316.106 257.608 316.239C259.616 316.407 258.947 319 257.859 318.832C256.989 318.699 256.549 318.442 256.437 318.331Z",
    stroke: "#040222",
    strokeWidth: 0.810791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241.189 218.897C241.189 218.897 238.858 218.567 237.964 216.331C237.093 214.094 237.799 209.55 239.824 209.433C241.848 209.291 241.189 218.897 241.189 218.897Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M275.112 233.54C275.112 233.54 273.37 223.793 272.617 217.131C271.863 210.492 271.063 204.324 270.663 202.276C270.262 200.227 267.885 192.906 265.177 190.363C262.446 187.844 260.233 187.162 257.644 186.855C255.054 186.549 251.429 186.361 249.192 186.855C246.956 187.35 246.155 188.503 245.166 188.692C244.178 188.88 242.859 189.916 242.2 191.211C241.517 192.529 240.787 193.353 240.505 194.365C240.222 195.378 239.775 197.332 239.446 198.297C239.116 199.262 238.527 203.053 238.622 203.453C238.716 203.853 239.304 203.994 239.587 203.853C239.587 203.853 239.493 208.42 239.587 209.527C239.681 210.633 240.858 225.394 242.53 231.915C244.201 238.436 246.249 242.109 252.723 243.239C255.958 243.806 258.683 243.721 260.793 242.683C259.066 243.59 256.671 244.022 253.359 243.357L257.553 267.264C262.063 262.898 262.564 260.178 264.139 256.455C266.071 251.588 269.156 245.523 270.71 242.792C272.263 240.061 275.418 235.352 275.112 233.54Z",
    fill: "#FAE900"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M257.553 267.264L253.359 243.357C263.906 245.476 265.154 236.459 265.154 236.459C263.6 242.91 259.174 244.369 252.723 243.239C246.249 242.109 244.201 238.436 242.53 231.915C240.858 225.394 239.681 210.633 239.587 209.527C239.493 208.42 239.587 203.853 239.587 203.853C239.304 203.994 238.716 203.853 238.622 203.453C238.527 203.053 239.116 199.262 239.446 198.297C239.775 197.332 240.222 195.378 240.505 194.365C240.787 193.353 241.517 192.529 242.2 191.211C242.859 189.916 244.178 188.88 245.166 188.692C246.155 188.503 246.956 187.35 249.192 186.855C251.429 186.361 255.054 186.549 257.644 186.855C260.233 187.162 262.446 187.844 265.177 190.363C267.885 192.906 270.262 200.227 270.663 202.276C271.063 204.324 271.863 210.492 272.617 217.131C273.37 223.793 275.112 233.54 275.112 233.54C275.418 235.352 272.263 240.061 270.71 242.792C269.156 245.523 266.071 251.588 264.139 256.455C262.564 260.178 262.063 262.898 257.553 267.264ZM257.553 267.264L253.83 247.218",
    stroke: "#040222",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M234.896 202.983C243.242 205.07 257.624 200.437 262.282 198.698L265.242 218.594C267.167 219.029 272.291 221.214 274.032 217.909C277.359 211.593 270.666 203.17 272.716 204.66C274.765 206.151 280.727 204.846 281.286 201.12C281.733 198.139 277.003 195.655 274.582 194.786C276.383 192.922 278.83 188.898 274.209 187.706C269.589 186.513 265.825 188.575 264.521 189.755C258.703 184.64 250.601 180.462 246.296 179.245C241.333 177.843 238.923 182.823 239.607 184.748C236.75 183.692 228.191 180.918 226.552 186.582C224.912 192.246 229.494 194.972 233.406 195.158C230.425 196.897 226.55 200.897 234.896 202.983Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.62158
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M255.041 195.153C255.041 195.153 251.95 192.254 250.844 192.559C249.776 192.864 250.501 195.382 248.746 194.123C246.991 192.864 244.702 190.957 243.176 192.444C241.65 193.932 240.925 194.619 237.911 192.826",
    stroke: "white",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M265.131 236.483C265.131 236.483 265.414 247.242 260.046 248.795C254.678 250.349 253.807 247.242 253.807 247.242L253.337 243.404C253.337 243.381 263.201 245.829 265.131 236.483Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M253.289 225.912C253.289 225.912 252.865 226.124 252.842 226.359C252.818 226.595 252.983 230.668 250.888 230.668C248.816 230.668 247.945 228.973 248.157 226.406",
    stroke: "#040222",
    strokeWidth: 0.827007,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M248.393 209.715C248.393 209.715 247.946 213.67 247.31 215.154C246.674 216.637 245.332 219.038 245.356 219.744C245.38 220.427 249.523 222.028 249.523 222.028",
    stroke: "#040222",
    strokeWidth: 0.827007,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M254.867 210.115C254.49 210.115 254.466 211.057 254.608 211.834C254.749 212.611 254.89 213.27 255.149 213.223C255.408 213.176 255.596 212.21 255.549 211.669C255.502 211.128 255.29 210.115 254.867 210.115Z",
    fill: "#040222"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M243.706 213.153C243.377 213.2 243.235 211.787 243.212 211.199C243.188 210.634 243.094 209.668 243.565 209.668C244.036 209.668 243.989 211.034 244.012 211.293C244.036 211.575 244.13 213.106 243.706 213.153Z",
    fill: "#040222"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M258.233 212.423C258.233 212.423 257.103 209.715 254.702 209.715C252.677 209.715 252.442 212.117 252.442 212.117",
    stroke: "#040222",
    strokeWidth: 0.827007,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M246.321 211.858C246.321 211.858 245.898 209.527 243.449 209.527C241.401 209.527 241.424 211.576 241.424 211.576",
    stroke: "#040222",
    strokeWidth: 0.827007,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M253.404 207.123C251.309 207.474 250.565 209.695 250.471 211.071C250.226 219.209 257.87 218.704 259.838 217.513C262.714 215.773 261.636 210.502 261.043 209.436C259.498 206.659 255.052 206.846 253.404 207.123Z",
    stroke: "#040222",
    strokeWidth: 0.810791
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M245.828 207.297C247.574 207.823 248.192 209.577 248.124 210.953C247.455 219.057 240.212 217.811 238.474 216.72C236.737 215.629 237.953 210.326 238.639 209.447C240.685 206.828 243.652 206.643 245.828 207.297Z",
    stroke: "#040222",
    strokeWidth: 0.810791
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M247.968 209.773C248.25 209.553 249.476 209.167 250.546 209.806",
    stroke: "#040222",
    strokeWidth: 0.810791
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.692 262.376L179.131 249.23L163.293 268.816L174.849 280.889L191.692 262.376Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M177.531 256.042L180.307 255.174L180.068 258.137",
    stroke: "white",
    strokeWidth: 1.62158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M176.847 258.861L176.473 261.177L179.249 260.615",
    stroke: "white",
    strokeWidth: 1.62158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M189.067 259.484L172.973 278.78L171.542 277.298L187.721 258.104L189.067 259.484Z",
    fill: "#040222"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M187.724 258.104L185.919 256.248L169.859 275.578L171.545 277.298L187.724 258.104Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M191.718 262.335L179.131 249.23L163.293 268.816L174.874 280.847L191.718 262.335Z",
    stroke: "#040222",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M215.758 258.175C220.636 258.175 224.59 254.221 224.59 249.343C224.59 244.465 220.636 240.511 215.758 240.511C210.88 240.511 206.925 244.465 206.925 249.343C206.925 254.221 210.88 258.175 215.758 258.175Z",
    fill: "#F1F3FF",
    stroke: "#040222",
    strokeWidth: 1.62158
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M224.59 249.343C224.59 249.343 220.637 249.343 215.758 249.343C210.879 249.343 206.925 249.343 206.925 249.343C206.925 244.464 210.879 240.511 215.758 240.511C220.637 240.511 224.59 244.472 224.59 249.343Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.62158
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215.759 252.29C220.637 252.29 224.591 250.97 224.591 249.343C224.591 247.715 220.637 246.396 215.759 246.396C210.881 246.396 206.926 247.715 206.926 249.343C206.926 250.97 210.881 252.29 215.759 252.29Z",
    fill: "#6F86FF",
    stroke: "#040222",
    strokeWidth: 1.62158
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M146.657 233.119L132.83 233.151L142.124 243.387L155.951 243.355L146.657 233.119Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.62158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M142.123 243.401L147.781 230.549L138.486 220.313L132.815 233.166L142.123 243.401Z",
    fill: "#6F86FF",
    stroke: "#040222",
    strokeWidth: 1.62158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M142.127 243.399L147.784 230.548L161.61 230.502L155.938 243.355L142.127 243.399Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.62158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M152.33 220.279L138.502 220.311L147.797 230.547L161.622 230.501L152.33 220.279Z",
    fill: "#F1F3FF",
    stroke: "#040222",
    strokeWidth: 1.62158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M144.384 305.836V321.786L151.25 346.014L238.809 339.782L243.575 326.278L229.788 327.036L231.606 309.47L219.895 315.729L220.097 296.751L207.176 308.057L200.715 285.848L187.793 307.249L178.212 292.317L171.44 307.855L155.083 292.553L154.847 311.434L144.384 305.836Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.62158,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M122.624 337.692H206.465L200.125 380.026H116.285L122.624 337.692Z",
    fill: "#4B1BAF",
    stroke: "#040222",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M159.347 337.692H243.188L236.848 380.026H153.007L159.347 337.692Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M121.428 262.238L136.983 258.186L159.49 337.689L143.935 341.741L121.428 262.238Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3574 262.51L121.648 262.51L143.862 341.845L107.572 341.845L85.3574 262.51Z",
    fill: "#4B1BAF",
    stroke: "#040222",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6565 258.767L136.924 258.096L121.186 262.528L85.3638 262.475L99.6565 258.767Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M267.48 315.806C268.845 311.286 282.476 267.851 282.476 267.851L304.394 288.474C302.346 307.284 292.665 328.923 287.439 339.234C282.236 349.546 249.313 368.984 232.272 373.316L223.709 348.74C240.75 344.985 266.114 320.326 267.48 315.806Z",
    fill: "#040222"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M237.749 376.71C238.219 376.003 238.775 372.36 239.199 371.513C301.447 347.048 292.423 327.888 304.394 288.474C304.394 288.474 306.678 297.891 299.757 324.658C289.95 363.768 248.602 373.557 245.848 376.782L237.749 376.71Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.65401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M225.341 352.751C220.167 349.517 213.222 346.272 208.252 345.603C203.034 344.9 203.836 347.509 205.141 348.111C208.675 349.742 211.285 350.082 213.972 351.724C206.36 354.112 197.117 352.101 193.564 351.874C189.796 351.633 190.071 355.4 193.653 356.146C196.519 356.743 204.997 357.888 208.878 358.385C205.196 359.132 197.045 359.255 193.083 359.011C188.527 358.731 188.369 362.16 193.994 363.076C195.515 363.32 197.57 363.709 199.768 364.078C196.062 365.286 193.104 366.538 195.333 367.823C198.063 369.396 210.458 368.355 216.068 367.777C213.157 368.394 206.826 369.628 204.79 369.628C202.245 369.628 201.55 371.652 203.054 372.52C204.558 373.387 218.498 372.173 222.778 370.553C226.202 369.257 229.141 367.7 230.182 367.083L225.341 352.751Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.62158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M282.476 267.851C282.476 267.851 268.845 311.286 267.48 315.806C266.114 320.326 240.75 344.985 223.709 348.74L232.272 373.316C249.313 368.984 282.236 349.546 287.439 339.234C292.665 328.923 302.346 307.284 304.394 288.474",
    stroke: "#040222",
    strokeWidth: 1.62158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M241.212 370.444C260.502 361.764 282.236 349.546 287.439 339.234C292.665 328.923 302.346 307.284 304.394 288.474",
    stroke: "white",
    strokeWidth: 0.810791,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M63 380.302H382.613",
    stroke: "black",
    strokeWidth: 1.62158,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M270.564 215.366C269.217 210.694 263.501 213.581 263.501 213.581L264.303 220.151C264.303 220.151 272.222 221.098 270.564 215.366Z",
    fill: "#FAE900"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M265.467 215.49C265.98 215.224 266.909 215.065 267.689 215.722M268.71 217.521C268.464 216.631 268.096 216.065 267.689 215.722M266.404 217.404L267.689 215.722",
    stroke: "black",
    strokeWidth: 0.810798,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M263.912 213.551C263.912 213.551 269.217 210.694 270.564 215.365C272.222 221.098 266.073 220.246 266.073 220.246",
    stroke: "#040222",
    strokeWidth: 0.764248,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M146.005 327.017L162.644 322.543L165.314 325.839L148.675 330.313L146.005 327.017Z",
    fill: "#6F86FF",
    stroke: "#040222",
    strokeWidth: 1.62158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M146.005 327.016L162.644 322.542L163.304 318.353L146.666 322.828L146.005 327.016Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.62158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M165.967 321.649L163.297 318.354L162.636 322.542L165.306 325.838L165.967 321.649Z",
    fill: "#F1F3FF",
    stroke: "#040222",
    strokeWidth: 1.62158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMaurice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/maurice.dd1dc2ded40dbbfc3830964efffeee4b.svg";